import { HttpResponse } from "../Service/HttpResponse";
const debug = console ? console.log : (...args) => { };
export class MocksAdapter {
    constructor() {
        /**
         * @type {{}}
         */
        this.mocks = {};
    }
    /**
     * @param match
     * @param method
     * @param response
     */
    mock(match, method, response) {
        this.mocks[match] = {
            method: method,
            response: response,
        };
    }
    /**
     * @param request
     * @returns {null}
     */
    send(request) {
        debug('Requesting ' + request.getPath());
        let found = false;
        let response = null;
        Object.keys(this.mocks).forEach(key => {
            if (found) {
                return;
            }
            if (request.getPath().match(new RegExp(key))) {
                if (this.mocks[key].method.toLowerCase() === request.getMethod().toLowerCase()) {
                    found = true;
                    response = this.mocks[key].response(request);
                }
            }
        });
        if (!found) {
            return Promise.reject(new HttpResponse(0, 'Mocks error', request, `[MOCKS ADAPTER] No match found for ${request.getPath()}`, {}));
        }
        return response.then(result => {
            debug('Loaded ' + request.getPath(), result);
            if (result instanceof HttpResponse) {
                return result;
            }
            return new HttpResponse(200, 'OK', request, result, {});
        });
    }
}
